import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterList } from '@mui/icons-material';
import { Button } from 'components/mui/common/Button';
import { Count } from 'components/mui/common/Tabs.styles';
import { compactButtonSx } from 'utils/styles';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  activeCount?: number;
  dataTestId?: string;
}

export const FilterButton = memo(({ onClick, disabled, activeCount = 0, dataTestId }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outlined"
      startIcon={<FilterList fontSize="small" />}
      onClick={onClick}
      endIcon={activeCount > 0 ? <Count>{activeCount}</Count> : undefined}
      disabled={disabled}
      data-testid={dataTestId ?? 'table-filters-button'}
      sx={compactButtonSx}>
      {t('common.filters')}
    </Button>
  );
});
